import styled, { css } from 'styled-components'

import { theme } from '@/styles/theme'

export type FormLabelProps = {
  text: string
  isRequired?: boolean | 'none'
  inputId: string
}

export const FormLabel = ({
  text,
  isRequired = false,
  inputId,
}: FormLabelProps) => {
  return (
    <Label data-required={isRequired} htmlFor={inputId}>
      {text}
    </Label>
  )
}

const LabelField = css`
  font-size: 14px;
  display: block;
  font-weight: normal;
  color: #fff;
  border-radius: 4px;
  padding: 0 14px;
  line-height: 22px;
  margin-right: 14px;
  letter-spacing: 0.28px;
  white-space: nowrap;
`

const Label = styled.label`
  font-size: 16px;
  font-weight: bold;
  line-height: 26px;
  letter-spacing: 0.32px;
  display: flex;
  align-items: baseline;

  &[data-required='true'] {
    &::before {
      ${LabelField};

      content: '必須';
      background-color: ${theme.colors.trialBlue};
    }
  }

  &[data-required='false'] {
    &::before {
      ${LabelField};

      content: '任意';
      background-color: ${theme.colors.grey};
    }
  }
`
